export const config = {
	apiKey: "AIzaSyB5GpY26mWfSiqcg2YHGIuP2jUhGjcUrzo",
	authDomain: "swipe-app-beemte-broekland.firebaseapp.com",
	projectId: "swipe-app-beemte-broekland",
	storageBucket: "swipe-app-beemte-broekland.appspot.com",
	messagingSenderId: "545364937328",
	appId: "1:545364937328:web:01198c9a06b241fbd902b5",
};
